import { useEffect, useState } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { CaretDown } from "@phosphor-icons/react";

const BASE = "https://www.estemsurucukursu.com";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(0);
  useEffect(() => { api.get("/faq").then(r => setFaqs(r.data)); }, []);

  // FAQPage + BreadcrumbList schema (Google "People Also Ask" için kritik)
  useEffect(() => {
    if (!faqs.length) return;
    const schemas = [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(f => ({
          "@type": "Question",
          "name": f.q,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": f.a
          }
        }))
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": BASE },
          { "@type": "ListItem", "position": 2, "name": "Sıkça Sorulan Sorular", "item": `${BASE}/sss` }
        ]
      }
    ];
    schemas.forEach((s, i) => {
      const id = `ld-faq-${i}`;
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.type = "application/ld+json"; document.head.appendChild(el); }
      el.textContent = JSON.stringify(s);
    });
    return () => {
      schemas.forEach((_, i) => { const el = document.getElementById(`ld-faq-${i}`); if (el) el.remove(); });
    };
  }, [faqs]);
  return (
    <>
      <SEO
        title="Sıkça Sorulan Sorular | Ehliyet Kursu SSS | Estem Gebze"
        description="Gebze sürücü kursu hakkında en çok sorulan sorular: ehliyet süresi, fiyatlar, gerekli belgeler, sınav tarihleri ve kayıt süreci. Estem SSS."
        canonical="https://www.estemsurucukursu.com/sss"
        keywords="gebze ehliyet soruları, sürücü kursu sss, ehliyet kaç ay sürer, ehliyet belgeler, sürücü kursu fiyat"
      />
      <section className="px-4 md:px-8 py-12 md:py-20 max-w-4xl mx-auto">
        <div className="nb-badge mb-4">SSS</div>
        <h1 className="font-heading font-bold text-5xl md:text-7xl tracking-tight leading-[1.05]">
          Sorular?<br/><span className="text-brand-primary">Hep yanındayız.</span>
        </h1>
        <div className="mt-12 space-y-4">
          {faqs.map((f, i) => (
            <div key={i} className="nb-card overflow-hidden" data-testid={`faq-${i}`}>
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full p-6 flex items-center justify-between text-left gap-4">
                <span className="font-heading font-bold text-lg md:text-xl">{f.q}</span>
                <CaretDown weight="bold" size={24} className={`shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`}/>
              </button>
              {open === i && <div className="px-6 pb-6 text-brand-muted border-t-2 border-brand-ink/10 pt-4">{f.a}</div>}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
